<div fxLayout="row" fxLayoutAlign="center center" fxFlexFill>
  <amplify-authenticator >
  </amplify-authenticator>
</div>
